// UserContext.js
import React, { createContext, useState, useEffect } from 'react';
import { AuthService } from '../services/AuthService';
import { useNavigate } from 'react-router-dom';

// Create a User Context
const UserContext = createContext(null);

const UserProvider = ({ children }) => {


    
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    useEffect(() => {
        if (user) {
            localStorage.setItem('user', JSON.stringify(user));
        } else {
            localStorage.removeItem('user');
        }
    }, [user]);

   
    const login = async (data, navigate) => {
        const { username: email, password } = data;
    
        if (!email || !password) {
            // Return an error message if fields are missing
            return "Plotësoni fushat e kërkuara";
        }
    
        try {
            const response = await AuthService.login({ userName: email, password });
    
            console.log("res", response);
    
            if (response && response?.id) {
                let userDetails = await AuthService.getUserById(response?.id);
                const updatedUserDetails = { ...userDetails, assignedStoreId: response?.storeId };
                setUser({ user: response, token: response.token, details: updatedUserDetails });
                if(updatedUserDetails?.roleName == "User"){
                    navigate("/articles");
                }else{
                    navigate("/dashboard");
                }
    
                // Optionally return a success message or null if you don't want to return anything
                return null;
            } else {
                return "Kyçja dështoi. Kontrolloni kredencialet.";
            }
        } catch (error) {
            console.error("Error during login:", error);
    
            // Return an error message if an exception occurs
            return "An error occurred during login. Please try again later.";
        }
    };

    // Log out function
    const logout = (navigate) => {
        setUser(null);  // Clear user state
        localStorage.removeItem('user');  // Remove from localStorage
        navigate("/login", { replace: true });
    };

    return (
        <UserContext.Provider value={{ user, login, logout }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider };